import styled from "styled-components";
import palette from "../../lib/styles/palette";
import { Link } from 'react-router-dom';
import Button from "../common/Button";

const AuthFormBlock = styled.div`
    h3 {
        margin: 0;
        color: ${palette.gray[8]};
        margin-bottom: 1rem;
    }
`;

const StyledInput = styled.input`
    font-size: 1rem;
    border: none;
    border-bottom: 1px solid ${palette.gray[5]};
    padding-bottom: 0.5rem;
    outline: none;
    width: 100%;
    &: focus {
        color: $oc-teal-7;
        border-bottom: 1px solid ${palette.gray[7]};
    }
    & + & {
        margin-top: 1rem;
    }
`;

/**
 * 폼 하단에 로그인 혹은 회원가입 링크를 보여줌
 */
const Footer = styled.div`
    margin-top: 2rem;
    text-align: right;
    a {
        color: ${palette.gray[6]};
        text-decoration: underline;
        &: hover {
            color: ${palette.gray[9]};
        }
    }
`;

/**
 *  에러를 보여준다.
 */
const ErrorMessage = styled.div`
    color: red;
    text-align: center;
    font-size: 0.875rem;
    margin-top: 1rem;
`;

const ButtonWithMarginTop = styled(Button)`
    margin-top: 1rem;
`;

const textMap = {
    login: 'Login',
    register: 'Register',
};

const AuthForm = ({ type, onSubmit, onChange, form, error }) => {

    return (
        <AuthFormBlock>
            <h3>{textMap[type]}</h3>
            <form onSubmit={onSubmit}>
                <StyledInput autoComplete="username" name="username" placeholder="ID" onChange={onChange} value={form.username} />
                <StyledInput autoComplete="new-password" name="password" placeholder="Password" type="password" onChange={onChange} value={form.password} />
                {type === 'register' && (
                    <StyledInput autoComplete="confirm-password" name="passwordConfirm" placeholder="Password Confirm" onChange={onChange} value={form.passwordConfirm} />
                )}
                {error && <ErrorMessage>{error}</ErrorMessage>}
                <ButtonWithMarginTop cyan fullWidth>{textMap[type]}</ButtonWithMarginTop>
            </form>
            <Footer>
                { type === 'login' ? (
                    <Link to="/register">Register</Link>
                ) : (
                    <Link to="/login">Login</Link>
                )}
            </Footer>
        </AuthFormBlock>
    );
};

export default AuthForm;